import axios from 'axios';
import lib from '@/lib';

export default class StatisticsModel {
	constructor() {
		this.playerProfileFullImageShow = false;
	}
}
